import { Outlet, useNavigate, Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { LangToggle, useT } from "@/lib/i18n";
import Footer from "@/components/Footer";

const NAV = [
  { to: "/cinematic-arsenal", label: "Arsenal" },
  { to: "/solutions", label: "Solutions" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/enterprise", label: "Enterprise" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
];

export default function PublicLayout() {
  const navigate = useNavigate();
  const { t, lp } = useT();
  return (
    <div className="min-h-screen bg-[#07080E] text-slate-100 relative grain">
      <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none" />
      <nav className="relative z-20 h-16 px-6 sm:px-10 flex items-center justify-between border-b border-white/10 sticky top-0 bg-[#07080E]/80 backdrop-blur-md">
        <Link to={lp("/")}><Logo size={34} /></Link>
        <div className="hidden md:flex items-center gap-6">
          {NAV.map((n) => (
            <Link key={n.to} to={lp(n.to)} data-testid={`pubnav-${n.to.replace("/", "")}`} className="text-sm text-slate-400 hover:text-white transition-colors">{t(n.label)}</Link>
          ))}
        </div>
        <LangToggle />
        <button data-testid="public-signin" onClick={() => navigate("/auth")} className="text-sm font-semibold px-4 py-2 rounded-full bg-gradient-to-r from-purple-600 to-cyan-600 text-white hover:scale-[1.03] transition-transform">Sign in</button>
      </nav>
      <div className="relative z-10">
        <Outlet />
      </div>
      <div className="relative z-10"><Footer /></div>
    </div>
  );
}
